module.exports = {
    "": {
        "project-id-version": "TS.InternetSales.Static",
        "report-msgid-bugs-to": "",
        "pot-creation-date": "2024-11-04 10:14-0500",
        "po-revision-date": "2024-11-04 10:18-0500",
        "last-translator": "Peter Perron <peter.perron@solutionstlm.com>",
        "language-team": "French <http://example.com/projects/internet-sales-30/internet-sales-20-is3-static/fr/>",
        "language": "fr",
        "mime-version": "1.0",
        "content-type": "text/plain; charset=UTF-8",
        "content-transfer-encoding": "8bit",
        "plural-forms": "nplurals=2; plural=n > 1;",
        "x-generator": "Poedit 3.4.2"
    },
    "# d’abonné ici": [
        null,
        "# d’abonné ici"
    ],
    "(valeur de {amount})": [
        null,
        "(valeur de {amount})"
    ],
    "* Le prix inclut les taxes et les frais de service de {fees} par billet. Quantités limitées.": [
        null,
        "* Le prix inclut les taxes et les frais de service de {fees} par billet. Quantités limitées."
    ],
    "--- Sélectionner un pays ---": [
        null,
        "--- Sélectionner un pays ---"
    ],
    ":": [
        null,
        " : "
    ],
    "A la": [
        null,
        "À la"
    ],
    "AUCUN": [
        null,
        "AUCUN"
    ],
    "Afin de pouvoir continuer vos achats, vous devez aller dans les options de votre navigateur pour procéder à l'activation de vos témoins (cookies).": [
        null,
        "Afin de pouvoir continuer vos achats, vous devez aller dans les options de votre navigateur pour procéder à l'activation de vos témoins (cookies)."
    ],
    "Afin de pouvoir continuer vos achats, vous devez autoriser la": [
        null,
        "Afin de pouvoir continuer vos achats, vous devez autoriser la"
    ],
    "Ajout d'une carte": [
        null,
        "Ajout d’une carte"
    ],
    "Ajouter": [
        null,
        "Ajouter"
    ],
    "Ajouter et continuer mes achats": [
        null,
        "Ajouter et continuer mes achats"
    ],
    "Ajouter une carte cadeau": [
        null,
        "Ajouter une carte cadeau"
    ],
    "Ajouter à mon panier d'achat au tarif {name}": [
        null,
        "Ajouter à mon panier d’achat au tarif {name}"
    ],
    "American Express": [
        null,
        "American Express"
    ],
    "Annuler": [
        null,
        "Annuler"
    ],
    "Au": [
        null,
        "Au"
    ],
    "Aucun": [
        null,
        "Aucun"
    ],
    "Aucun profil est connecte, la page sera actualisee": [
        null,
        "Aucun profil est connecté, la page sera actualisée"
    ],
    "Aucune date disponible": [
        null,
        "Aucune date disponible"
    ],
    "Aucune représentation disponible pour le moment...": [
        null,
        "Aucune représentation disponible pour le moment..."
    ],
    "Autoriser la billetterie Reservatech.net pour l'achat de mes billets": [
        null,
        "Autoriser la billetterie Reservatech.net pour l'achat de mes billets"
    ],
    "Autre": [
        null,
        "Autre"
    ],
    "Autre methode": [
        null,
        "Autre méthode"
    ],
    "Avant de procéder": [
        null,
        "Avant de procéder"
    ],
    "Billet bloqué": [
        null,
        "Billet bloqué"
    ],
    "Billet désactivé": [
        null,
        "Billet désactivé"
    ],
    "Billet remplacé": [
        null,
        "Billet remplacé"
    ],
    "Billet réimprimé": [
        null,
        "Billet réimprimé"
    ],
    "Billets en trop : {qty}": [
        null,
        "Billets en trop : {qty}"
    ],
    "Billets non distribués : {qty}": [
        null,
        "Billets non distribués : {qty}"
    ],
    "Carte cadeau": [
        null,
        "Carte cadeau"
    ],
    "Ce siege ne vous convient pas? Cliquez sur le plan pour chercher un billet a l'endroit de votre choix.": [
        "Ces places ne vous conviennent pas? Cliquez sur le plan pour chercher des billets a l'endroit de votre choix.",
        "Ce siège ne vous convient pas? Cliquez sur le plan pour chercher un billet à l'endroit de votre choix.",
        "Ces places ne vous conviennent pas? Cliquez sur le plan pour chercher des billets à l'endroit de votre choix."
    ],
    "Certains billets de votre sélection sont déjà dans votre panier d'achats.": [
        null,
        "Certains billets de votre sélection sont déjà dans votre panier d’achats."
    ],
    "Changer": [
        null,
        "Changer"
    ],
    "Chargement de la programmation en cours...": [
        null,
        "Chargement de la programmation en cours..."
    ],
    "Chargement des dates en cours...": [
        null,
        "Chargement des dates en cours..."
    ],
    "Chargement...": [
        null,
        "Chargement…"
    ],
    "Chercher": [
        null,
        "Chercher"
    ],
    "Chercher dans une autre section": [
        null,
        "Chercher dans une autre section"
    ],
    "Chercher les meilleures places": [
        null,
        "Chercher les meilleures places"
    ],
    "Choisir sur le plan": [
        null,
        "Choisir sur le plan"
    ],
    "Choisissez un evenement parmi les suivants": [
        "Choisissez {n} evenements parmi les suivants",
        "Choisissez un événement parmi les suivants",
        "Choisissez {n} événements parmi les suivants"
    ],
    "Choisissez votre promotion": [
        null,
        "Choisissez votre promotion"
    ],
    "Choisissez votre tarif": [
        null,
        "Choisissez votre tarif"
    ],
    "Choix de places": [
        null,
        "Choix de places"
    ],
    "Choix du tarif": [
        null,
        "Choix du tarif"
    ],
    "Cliquez ici si vous désirez la désactiver.": [
        null,
        "Cliquez ici si vous désirez la désactiver."
    ],
    "Cliquez sur le plan pour chercher des sieges a l'endroit de votre choix.": [
        null,
        "Cliquez sur le plan pour chercher des sièges à l'endroit de votre choix."
    ],
    "Cliquez sur le plan pour sélectionner les sièges de votre choix": [
        null,
        "Cliquez sur le plan pour sélectionner les sièges de votre choix"
    ],
    "Cliquez sur les sièges que vous désirez réserver.": [
        null,
        "Cliquez sur les sièges que vous désirez réserver."
    ],
    "Code incorrect": [
        null,
        "Code incorrect"
    ],
    "Code postal": [
        null,
        "Code postal"
    ],
    "Combien de billets désirez-vous?": [
        null,
        "Combien de billets désirez-vous?"
    ],
    "Combien de forfaits désirez-vous?": [
        null,
        "Combien de forfaits désirez-vous?"
    ],
    "Compléter votre forfait parmi les événements suivants": [
        null,
        "Compléter votre forfait parmi les événements suivants"
    ],
    "Confirmer": [
        null,
        "Confirmer"
    ],
    "Continuer en tant qu'invité": [
        null,
        "Continuer en tant qu'invité"
    ],
    "Courriel invalide": [
        null,
        "Courriel invalide"
    ],
    "D'accord!": [
        null,
        "D'accord!"
    ],
    "Dans quelle section": [
        null,
        "Dans quelle section"
    ],
    "Date à déterminer": [
        null,
        "Date à déterminer"
    ],
    "Devenir membre": [
        null,
        "Devenir membre"
    ],
    "Donnée inaccessible": [
        null,
        "Donnée inaccessible"
    ],
    "Décharge de responsabilité": [
        "Décharges de responsabilité",
        "Décharge de responsabilités",
        "Décharges de responsabilités"
    ],
    "Désirez-vous vraiment annuler votre réservation pour l'événement à venir?": [
        null,
        "Désirez-vous vraiment annuler votre réservation pour l’événement à venir?"
    ],
    "Désolé, certains billets de votre sélection ne sont plus disponibles. Veuillez en choisir de nouveau.": [
        null,
        "Désolé, certains billets de votre sélection ne sont plus disponibles. Veuillez en choisir de nouveau."
    ],
    "Enlever 1 billet pour profiter de ce tarif": [
        "Enlever {n} billets pour profiter de ce tarif",
        "Enlever 1 billet pour profiter de ce tarif",
        "Enlever {n} billets pour profiter de ce tarif"
    ],
    "Entrez votre # d’abonné ici": [
        null,
        "Entrez votre # d’abonné ici"
    ],
    "Envoyer": [
        null,
        "Envoyer"
    ],
    "Erreur lors de la recherche de billets à cet endroit.": [
        null,
        "Erreur lors de la recherche de billets à cet endroit."
    ],
    "Fermer la session": [
        null,
        "Fermer la session"
    ],
    "File d'attente": [
        null,
        "File d'attente"
    ],
    "Frais de livraison": [
        null,
        "Frais de livraison"
    ],
    "ICI": [
        null,
        "ICI"
    ],
    "IMPORTANT": [
        null,
        "IMPORTANT"
    ],
    "Identifiez-vous": [
        null,
        "Identifiez-vous"
    ],
    "Il n'y a aucun tarif disponible dans cette section pour le moment. Veuillez sélectionner un autre siège.": [
        null,
        "Il n’y a aucun tarif disponible dans cette section pour le moment. Veuillez sélectionner un autre siège."
    ],
    "Il vous manque encore un evenement dans votre choix pour continuer.": [
        "Il vous manque encore {n} evenements dans votre choix pour continuer.",
        "Il vous manque encore un événement dans votre choix pour continuer",
        "Il vous manque encore {n} événements dans votre choix pour continuer."
    ],
    "Il vous manque encore un evenement obligatoire dans votre choix pour continuer.": [
        "Il vous manque encore {n} evenements oligatoires dans votre choix pour continuer.",
        "Il vous manque encore un événement obligatoire à sélectionner",
        "Il vous manque encore {n} événements obligatoires à sélectionner"
    ],
    "Inclut des frais de": [
        null,
        "Inclut des frais de"
    ],
    "Infolettre": [
        "Infolettres",
        "Infolettre",
        "Infolettres"
    ],
    "Informations d'inscription": [
        null,
        "Formulaire Informations"
    ],
    "Informations du compte Reservatech.net": [
        null,
        "Informations du compte Reservatech.net"
    ],
    "Inscrire votre pays": [
        null,
        "Inscrire votre pays"
    ],
    "Inscrivez vos informations pour que nous puissions vous contacter en cas de supplémentaire.": [
        null,
        "Inscrivez vos informations pour que nous puissions vous contacter en cas de supplémentaire."
    ],
    "Invalide - {reason}": [
        null,
        "Invalide - {reason}"
    ],
    "J'accepte que mon adresse courriel soit partagée aux producteurs pour l'inscription à des infolettres": [
        null,
        "J’accepte que mon adresse courriel soit partagée aux producteurs pour l’inscription à des infolettres"
    ],
    "J'ai activé mes cookies, réessayer": [
        null,
        "J'ai activé mes cookies, réessayer"
    ],
    "J'ai lu et accepte la": [
        null,
        "J'ai lu et accepte la"
    ],
    "J'ai lu et accepte la décharge": [
        null,
        "J'ai lu et accepte la décharge"
    ],
    "J'ai lu et accepte les": [
        null,
        "J'ai lu et accepte les"
    ],
    "J'ai lu et accepte les politiques d'achats": [
        null,
        "J'ai lu et accepte les politiques d'achats"
    ],
    "Je désire faire une demande de modification": [
        null,
        "Je désire faire une demande de modification"
    ],
    "Je désire renouveler": [
        null,
        "Je désire renouveler"
    ],
    "Je ne souhaite pas renouveler": [
        null,
        "Je ne souhaite pas renouveler"
    ],
    "Je paie avec {name}": [
        null,
        "Je paie avec {name}"
    ],
    "Je récupérerai mes billets au guichet": [
        null,
        "Au guichet"
    ],
    "Je suis membre": [
        null,
        "Je suis membre"
    ],
    "Je veux": [
        null,
        "Je veux"
    ],
    "L'achat de billet en ligne est propulsé par la billetterie": [
        null,
        "L'achat de billet en ligne est propulsé par la billetterie"
    ],
    "L'item que vous désirez retirer du panier est nécéssaire pour le produit suivant": [
        "L'item que vous désirez retirer est nécéssaire pour les produits suivants",
        "L'item que vous désirez retirer du panier est nécéssaire pour le produit suivant",
        "L'item que vous désirez retirer est nécéssaire pour les produits suivants"
    ],
    "La carte n'est pas utilisable pour chacun des événements de votre panier.": [
        null,
        "La carte n’est pas utilisable pour chacun des événements de votre panier."
    ],
    "Laissez votre navigateur ouvert sur cette page et surveillez la. Lorsque votre tour sera venu, l'achat de billet apparaîtra. Prenez garde, actualiser cette page empêcherait votre navigateur de vérifier si le système vous a attribué une place.": [
        null,
        "Laissez votre navigateur ouvert sur cette page et surveillez la. Lorsque votre tour sera venu, l'achat de billet apparaîtra. Prenez garde, actualiser cette page empêcherait votre navigateur de vérifier si le système vous a attribué une place."
    ],
    "Le forfait n'est plus en vente présentement": [
        null,
        "Le forfait n'est plus en vente présentement"
    ],
    "Le montant de la carte cadeau entrée est insuffisant.": [
        null,
        "Le montant de la carte est insuffisant."
    ],
    "Le montant de la carte cadeau entrée est invalide.": [
        null,
        "Le montant de la carte entrée est invalide."
    ],
    "Le nombre de forfait a été épuisés": [
        null,
        "Le nombre de forfait a été épuisés"
    ],
    "Le numéro de carte est invalide.": [
        null,
        "Le numéro de carte est invalide."
    ],
    "Limite atteinte!": [
        null,
        "Limite atteinte!"
    ],
    "Manque 1 billet pour profiter de ce tarif": [
        "Manque {n} billets pour profiter de ce tarif",
        "Manque 1 billet pour profiter de ce tarif",
        "Manque {n} billets pour profiter de ce tarif"
    ],
    "Manque 1 billet pour profiter de cette vente": [
        "Manque {n} billets pour profiter de cette vente",
        "Manque 1 billet pour profiter de cette vente",
        "Manque {n} billets pour profiter de cette vente"
    ],
    "Maximum de 1 billet par commande": [
        "Maximum de {n} billets par commande",
        "Maximum de 1 billet par commande",
        "Maximum de {n} billets par commande"
    ],
    "Merci !": [
        null,
        "Merci !"
    ],
    "Merci de patienter.": [
        null,
        "Merci de patienter."
    ],
    "Mise en vente": [
        null,
        "Mise en vente"
    ],
    "Modifier": [
        null,
        "Modifier"
    ],
    "Modifier le formulaire": [
        null,
        "Modifier le formulaire"
    ],
    "Modifier le formulaire du panier": [
        null,
        "Modifier le formulaire du panier"
    ],
    "Modifier vos informations d'inscription": [
        null,
        "Modifier votre formulaire"
    ],
    "Mon panier": [
        null,
        "Mon panier"
    ],
    "Montant": [
        null,
        "Montant"
    ],
    "Montant personnalisé": [
        null,
        "Montant personnalisé"
    ],
    "Montant à payer": [
        null,
        "Montant à payer"
    ],
    "Montants": [
        null,
        "Montants"
    ],
    "Mot de passe incorrect": [
        null,
        "Mot de passe incorrect"
    ],
    "Mot de passe oublié ?": [
        null,
        "Mot de passe oublié ?"
    ],
    "Ne pas actualiser cette page - Le système travaille pour vous!": [
        null,
        "Ne pas actualiser cette page - Le système travaille pour vous!"
    ],
    "No civique et rue": [
        null,
        "No civique et rue"
    ],
    "Nombre de billets désirés": [
        null,
        "Nombre de billets désirés"
    ],
    "Nombre de participants": [
        null,
        "Nombre de participants"
    ],
    "Non disponible": [
        null,
        "Non disponible"
    ],
    "Non, conservez mes billets": [
        null,
        "Non, conservez mes billets"
    ],
    "Nous vous enverrons un courriel contenant un lien. Veuillez cliquer sur ce lien pour réinitialiser votre mot de passe.": [
        null,
        "Nous vous enverrons un courriel contenant un lien. Veuillez cliquer sur ce lien pour réinitialiser votre mot de passe."
    ],
    "Numéro de carte invalide!": [
        null,
        "Numéro de carte invalide!"
    ],
    "Nécessite 1 billet pour profiter de ce tarif": [
        "Nécessite {n} billets pour profiter de ce tarif",
        "Nécessite 1 billet pour profiter de ce tarif",
        "Nécessite {n} billets pour profiter de ce tarif"
    ],
    "Nécessite un multiple de 1 billet pour profiter de ce tarif": [
        "Nécessite un multiple de {n} billets pour profiter de ce tarif",
        "Nécessite un multiple de 1 billet pour profiter de ce tarif",
        "Nécessite un multiple de {n} billets pour profiter de ce tarif"
    ],
    "Nécessite un multiple de 1 billet pour profiter de cette vente": [
        "Nécessite un multiple de {n} billets pour profiter de cette vente",
        "Nécessite un multiple de 1 billet pour profiter de cette vente",
        "Nécessite un multiple de {n} billets pour profiter de cette vente"
    ],
    "Nécessite une carte de crédit {creditCardName}": [
        null,
        "Nécessite une carte de crédit {creditCardName}"
    ],
    "Nécessite une carte {cardName}": [
        null,
        "Nécessite une carte {cardName}"
    ],
    "OK": [
        null,
        "OK"
    ],
    "Oui, annulez ma réservation": [
        null,
        "Oui, annulez ma réservation"
    ],
    "Participants confirmés": [
        null,
        "Participants confirmés"
    ],
    "Passer à la caisse": [
        null,
        "Passer à la caisse"
    ],
    "Plus d'informations...": [
        null,
        "Plus d’informations…"
    ],
    "Politique d'achat": [
        "Politiques d'achat",
        "Politique d'achat",
        "Politiques d'achats"
    ],
    "Pour plus d’informations sur cette procédure, n’hésitez pas à communiquer avec la billetterie au {phone} ou, sans frais, au {tollfree}.": [
        null,
        "Pour plus d’informations sur cette procédure, n’hésitez pas à communiquer avec la billetterie au {phone} ou, sans frais, au {tollfree}."
    ],
    "Pour plus d’informations sur cette procédure, n’hésitez pas à communiquer avec la billetterie.": [
        null,
        "Pour plus d’informations sur cette procédure, n’hésitez pas à communiquer avec la billetterie."
    ],
    "Pour plus d’informations sur cette procédure, vous retrouverez l'information de blocage/activation des témoins (cookies) en cliquant": [
        null,
        "Pour plus d’informations sur cette procédure, vous retrouverez l'information de blocage/activation des témoins (cookies) en cliquant"
    ],
    "Promotion non trouvée": [
        null,
        "Promotion non trouvée"
    ],
    "Quantité désirée ": [
        null,
        "Quantité désirée "
    ],
    "Quantités": [
        null,
        "Quantités"
    ],
    "Quels montants désirez-vous?": [
        null,
        "Quels montants désirez-vous?"
    ],
    "Recherche avancée": [
        null,
        "Recherche avancée"
    ],
    "Requis": [
        null,
        "Requis"
    ],
    "Reservatech.net": [
        null,
        "Reservatech.net"
    ],
    "Retirer aussi ce produit du panier": [
        "Retirer aussi tous ces produits du panier",
        "Retirer aussi ce produit du panier",
        "Retirer aussi tous ces produits du panier"
    ],
    "Récupération de votre commande": [
        null,
        "Récupération de votre commande"
    ],
    "SUIVANT": [
        null,
        "SUIVANT"
    ],
    "Si vous détenez un **CODE DE PROMOTION**, cliquez ici.": [
        null,
        "Si vous détenez un **CODE DE PROMOTION**, cliquez ici."
    ],
    "Si vous ne voyez pas votre nom dans la liste et que vous vous êtes inscrit en ligne": [
        null,
        "Si vous ne voyez pas votre nom dans la liste et que vous vous êtes inscrit en ligne"
    ],
    "Siege propose": [
        "Sieges proposes",
        "Siège proposé",
        "Sièges proposés"
    ],
    "Sous total": [
        null,
        "Sous total"
    ],
    "Sélection de billets": [
        null,
        "Sélection de billets"
    ],
    "Sélectionner un tarif": [
        null,
        "Sélectionner un tarif"
    ],
    "Sélectionnez une section": [
        null,
        "Sélectionnez une section"
    ],
    "TOUS": [
        null,
        "TOUS"
    ],
    "Temps restant": [
        null,
        "Temps restant"
    ],
    "Total": [
        null,
        "Total"
    ],
    "Total de la facture": [
        null,
        "Total de la facture"
    ],
    "Tous": [
        null,
        "Tous"
    ],
    "Toute les sections": [
        null,
        "Toutes les sections"
    ],
    "Transaction refusée": [
        null,
        "Transaction refusée"
    ],
    "Trouvez-moi": [
        null,
        "Trouvez-moi"
    ],
    "Téléphone": [
        null,
        "Téléphone"
    ],
    "Une erreur est survenue": [
        null,
        "Une erreur est survenue"
    ],
    "Une erreur est survenue ({key})": [
        null,
        "Une erreur est survenue ({key})"
    ],
    "Une erreur est survenue. Veuillez réessayer plus tard.": [
        null,
        "Une erreur est survenue. Veuillez réessayer plus tard."
    ],
    "Utiliser une carte cadeau": [
        null,
        "Utiliser une carte cadeau"
    ],
    "Utilisez ce code lors du paiement pour échanger votre carte cadeau.": [
        null,
        "Utilisez ce code lors du paiement pour échanger votre carte cadeau."
    ],
    "Utilisez ce code lors du paiement pour échanger votre chèque-cadeau.": [
        null,
        "Utilisez ce code lors du paiement pour échanger votre carte cadeau."
    ],
    "Validation de la carte": [
        null,
        "Validation de la carte"
    ],
    "Valider": [
        null,
        "Valider"
    ],
    "Version imprimable": [
        null,
        "Version imprimable"
    ],
    "Veuillez augmenter votre luminosité": [
        null,
        "Veuillez augmenter votre luminosité"
    ],
    "Veuillez entrer le code de promotion": [
        null,
        "Veuillez entrer le code de promotion"
    ],
    "Veuillez entrer le numéro de votre carte cadeau": [
        null,
        "Veuillez entrer le numéro de votre carte cadeau"
    ],
    "Veuillez entrer les 4 premiers chiffres de votre carte de débit Desjardins": [
        null,
        "Veuillez entrer votre numéro de carte de débit Desjardins (16 chiffres)"
    ],
    "Veuillez entrer un code promo": [
        null,
        "Veuillez entrer un code promo"
    ],
    "Veuillez patentier...": [
        null,
        "Veuillez patentier…"
    ],
    "Veuillez remplir vos informations d'inscription": [
        null,
        "Veuillez remplir le formulaire pour continuer"
    ],
    "Veuillez sélectionner la méthode de récupération": [
        null,
        "Veuillez sélectionner la méthode de récupération"
    ],
    "Visionner sur le plan": [
        null,
        "Visionner sur le plan"
    ],
    "Voir notre promotion": [
        "Voir nos promotions",
        "Voir notre promotion",
        "Voir nos promotions"
    ],
    "Voir plus d'informations": [
        null,
        "Voir plus d’informations"
    ],
    "Vos cartes cadeaux électroniques": [
        null,
        "Vos cartes cadeaux électroniques"
    ],
    "Vos cartes de membres": [
        null,
        "Vos cartes de membres"
    ],
    "Vos chèques-cadeaux électroniques": [
        null,
        "Vos chèques-cadeaux électroniques"
    ],
    "Vos coordonnées": [
        null,
        "Vos coordonnées"
    ],
    "Vos produits": [
        null,
        "Vos produits"
    ],
    "Vos témoins (cookies) sont désactivés": [
        null,
        "Vos témoins (cookies) sont désactivés"
    ],
    "Votre carte cadeau électronique": [
        null,
        "Votre carte cadeau électronique"
    ],
    "Votre chèque-cadeau électronique": [
        null,
        "Votre chèque-cadeau électronique"
    ],
    "Votre nombre de forfaits ": [
        null,
        "Votre nombre de forfaits "
    ],
    "Votre panier": [
        null,
        "Votre panier"
    ],
    "Votre panier d'achat": [
        null,
        "Votre panier d'achat"
    ],
    "Votre panier est presentement vide, la page sera actualisee": [
        null,
        "Votre panier est présentement vide, la page sera actualisée"
    ],
    "Votre panier est présentement vide, la page sera actualisee": [
        null,
        "Votre panier est présentement vide, la page sera actualisée"
    ],
    "Votre sélection": [
        null,
        "Votre sélection"
    ],
    "Votre sélection laisse un ou plusieurs siège(s) vide(s) isolé(s) dans la salle. Veuillez modifier votre sélection.": [
        null,
        "Votre sélection laisse un ou plusieurs siège(s) vide(s) isolé(s) dans la salle. Veuillez modifier votre sélection."
    ],
    "Voulez-vous vraiment retirer ce billet?": [
        "Voulez-vous vraiment retirer ces billets?",
        "Voulez-vous vraiment retirer ce billet?",
        "Voulez-vous vraiment retirer ces billets?"
    ],
    "Vous avez déjà entré cette carte cadeau.": [
        null,
        "Vous avez déjà entré cette carte cadeau."
    ],
    "Vous avez dépassé le nombre d'evenements autorises de {n} pour continuer.": [
        null,
        "Vous avez dépassé le nombre d'événements autorisés de {n}"
    ],
    "Vous avez dépassé le nombre d'evenements obligatoire autorises de {n} pour continuer.": [
        null,
        "Vous avez dépassé le nombre d'événements autorisés de {n}"
    ],
    "Vous avez un code promo?": [
        null,
        "Vous avez un code promo?"
    ],
    "Vous avez une promotion présentement active.": [
        null,
        "Vous avez une promotion présentement active."
    ],
    "Vous avez votre place! Nous vous transférons à cet": [
        null,
        "Vous avez votre place! Nous vous transférons à cet"
    ],
    "Vous devez accepter les décharges de responsabilités": [
        null,
        "Vous devez accepter les décharges de responsabilités"
    ],
    "Vous devez accepter les décharges de responsabilités et les politiques d'achats": [
        null,
        "Vous devez accepter les décharges de responsabilités et les politiques d'achats"
    ],
    "Vous devez accepter les politiques d'achats": [
        null,
        "Vous devez accepter les politiques d'achats"
    ],
    "Vous devez choisir de {min} à {max} items de la liste suivante": [
        null,
        "Vous devez choisir de {min} à {max} items de la liste suivante"
    ],
    "Vous devez choisir {n} items de la liste suivante": [
        null,
        "Vous devez choisir {n} items de la liste suivante"
    ],
    "Vous devez entrer le code postal de facturation": [
        null,
        "Vous devez entrer le code postal de facturation"
    ],
    "Vous devez entrer le pays de facturation": [
        null,
        "Vous devez entrer le pays de facturation"
    ],
    "Vous devez entrer un nombre": [
        null,
        "Vous devez entrer un nombre"
    ],
    "Vous devez entrer vos coordonnées": [
        null,
        "Vous devez entrer vos coordonnées"
    ],
    "Vous devrez entrer votre adresse de facturation": [
        null,
        "Vous devrez entrer votre adresse de facturation"
    ],
    "Vous êtes enregistré sur la liste de rappel.": [
        null,
        "Vous êtes enregistrés sur la liste de rappel."
    ],
    "Vous êtes présentement dans la file d'attente d'accès à l'achat de billet.": [
        null,
        "Vous êtes présentement dans la file d'attente d'accès à l'achat de billet."
    ],
    "Vous êtes toujours présent(e) dans la file d'attente et vous conserver votre priorité.": [
        null,
        "Vous êtes toujours présent(e) dans la file d'attente et vous conserver votre priorité."
    ],
    "ans": [
        null,
        "ans"
    ],
    "billets": [
        null,
        "billets"
    ],
    "billetterie": [
        null,
        "billetterie"
    ],
    "browsing.back": [
        null,
        "Retour"
    ],
    "browsing.processing": [
        null,
        "Traitement en cours..."
    ],
    "button.cancel": [
        null,
        "Annuler"
    ],
    "buypackage.betweeneventstitle": [
        null,
        "Choisissez entre {min} et {max} événements parmi les suivants"
    ],
    "buypackage.eventtitle": [
        null,
        "Vous devez choisir des événements parmi les suivants"
    ],
    "buypackage.mandatorytitle": [
        null,
        "Vous devez choisir au moins un des événements suivants"
    ],
    "buypackage.overviewtitle": [
        null,
        "Vos événements pour ce forfait"
    ],
    "cartcontent.boxoffice": [
        null,
        "Au guichet"
    ],
    "cartcontent.confirmremoveitem": [
        null,
        "Êtes-vous certain de retirer cet item de votre panier?"
    ],
    "cartcontent.confirmtitle": [
        null,
        "Confirmation"
    ],
    "cartcontent.dateformat": [
        null,
        "dddd Do MMMM, YYYY, H[h]mm"
    ],
    "cartcontent.description": [
        null,
        "Description"
    ],
    "cartcontent.eticket": [
        null,
        "Billet électronique"
    ],
    "cartcontent.hidedetails": [
        null,
        "Cacher les détails"
    ],
    "cartcontent.itemDependancyPanel.cannotRemoveTitle": [
        null,
        "Attention"
    ],
    "cartcontent.mail": [
        null,
        "Par la poste"
    ],
    "cartcontent.price": [
        null,
        "Prix"
    ],
    "cartcontent.quantity": [
        null,
        "Quantité"
    ],
    "cartcontent.remove": [
        null,
        "retirer"
    ],
    "cartcontent.removeitem": [
        null,
        "retirer du panier"
    ],
    "cartcontent.setdeliverymethod": [
        null,
        "Récupération de vos billets"
    ],
    "cartcontent.shippingfee": [
        null,
        "Frais de livraison :"
    ],
    "cartcontent.showdetails": [
        null,
        "Afficher les détails"
    ],
    "cartcontent.total": [
        null,
        "Total :"
    ],
    "cartcontent.venue": [
        null,
        "Endroit :"
    ],
    "cartwidget.cart": [
        null,
        "Panier"
    ],
    "cartwidget.checkout": [
        null,
        "Passer à la caisse"
    ],
    "cartwidget.continueshopping": [
        null,
        "Continuer vos achats"
    ],
    "cartwidget.logout": [
        null,
        "Fermer la session"
    ],
    "cartwidget.pleasewait": [
        null,
        "Chargement du panier en cours..."
    ],
    "cartwidget.timeelapsed": [
        null,
        "Temps écoulé"
    ],
    "cartwidget.title": [
        null,
        "Voici le contenu de votre panier d'achat"
    ],
    "cartwidget.yourcartisempty": [
        null,
        "Votre panier d'achat est vide"
    ],
    "code promo": [
        null,
        "code promo"
    ],
    "creditcard.cardHolderName": [
        null,
        "Titulaire de la carte"
    ],
    "creditcard.cardNumber": [
        null,
        "Numéro de la carte"
    ],
    "creditcard.endingWith": [
        null,
        "se terminant par {number}"
    ],
    "creditcard.expirationDate": [
        null,
        "Date d'expiration"
    ],
    "creditcard.masterCardAndVisa": [
        null,
        "MasterCard et Visa"
    ],
    "creditcard.rememberForNextPurchases": [
        null,
        "Se souvenir de cette carte pour mes achats futurs"
    ],
    "creditcard.verificationNumber": [
        null,
        "Code à trois chiffres"
    ],
    "creditcard.whereToFindIt": [
        null,
        "Où le trouver?"
    ],
    "creditcard.withoutSpaces": [
        null,
        "sans les espaces"
    ],
    "décharge": [
        null,
        "décharge"
    ],
    "en savoir plus...": [
        null,
        "en savoir plus..."
    ],
    "endroit...": [
        null,
        "endroit..."
    ],
    "erroronaction.title": [
        null,
        "Attention"
    ],
    "general.colon": [
        null,
        " : "
    ],
    "general.communicationerroroccuredpleaseretry": [
        null,
        "Une erreur de communication est survenue. Veuillez essayer de nouveau."
    ],
    "general.invalidoperation": [
        null,
        "Opération invalide"
    ],
    "le {date}": [
        null,
        "le {date}"
    ],
    "login.cancel": [
        null,
        "Annuler"
    ],
    "login.confirm": [
        null,
        "Confirmer"
    ],
    "login.connection": [
        null,
        "Connectez-vous"
    ],
    "login.createaccount": [
        null,
        "Créer un compte"
    ],
    "login.email": [
        null,
        "Adresse courriel"
    ],
    "login.failedauthmsg": [
        null,
        "La combinaison du mot de passe et du courriel est invalide"
    ],
    "login.forgotpassword": [
        null,
        "Mot de passe oublié?"
    ],
    "login.noaccount": [
        null,
        "Je n'ai pas de profil"
    ],
    "login.password": [
        null,
        "Mot de passe"
    ],
    "login.passwordResetEmailFailed": [
        null,
        "Une erreur s'est produite lors de l'envoi, veuillez réessayer dans quelques instants"
    ],
    "login.passwordResetEmailSuccess": [
        null,
        "Un courriel de réinitilisation de mot de passe a été envoyé à cette adresse"
    ],
    "login.passwordResetTitle": [
        null,
        "Entrez le courriel de votre profil"
    ],
    "membership.addcarderror.card.notinsale": [
        null,
        "Cette carte de membre n'est plus en vente pour le moment"
    ],
    "membership.addcarderror.card.soldout": [
        null,
        "Toutes les cartes ont été vendus"
    ],
    "membership.addcarderror.card.ticketnotfound": [
        null,
        "Il n'y a pas de cartes disponibles pour le moment"
    ],
    "membership.addcarderror.card.toomanytickets": [
        null,
        "Le nombre de cartes dépasse la limite permise par transaction"
    ],
    "membership.addcarderror.price.default": [
        null,
        "Ce tarif n'est présentement plus en vente"
    ],
    "membership.addcarderror.price.saleended": [
        null,
        "Ce tarif n'est plus en vente"
    ],
    "membership.addcarderror.price.salenotstartyet": [
        null,
        "La vente de ce tarif carte de membre n'est pas encore débutée"
    ],
    "membership.addcarderror.price.soldout": [
        null,
        "Il n'y a plus de carte disponible pour ce tarif"
    ],
    "membership.alreadyamember": [
        null,
        "Déjà membre?"
    ],
    "membership.cardnotfound": [
        null,
        "Carte non trouvée"
    ],
    "membership.enteryourcardnumberhere": [
        null,
        "Entrez votre numéro de carte ici"
    ],
    "membership.membershipcardnumber": [
        null,
        "numéro de carte de membre"
    ],
    "membership.youarenotamember": [
        null,
        "Vous n'êtes pas membre?"
    ],
    "month": [
        null,
        "mois"
    ],
    "ordervalidation.accept": [
        null,
        "J'ai lu et accepte les"
    ],
    "ordervalidation.addoptions": [
        null,
        "Options supplémentaires"
    ],
    "ordervalidation.editprofile": [
        null,
        "Éditer votre profil"
    ],
    "ordervalidation.loading": [
        null,
        "Changement en cours"
    ],
    "ordervalidation.policies": [
        null,
        " politiques d'achats"
    ],
    "ordervalidation.profileaddress": [
        null,
        "Adresse du profil"
    ],
    "ordervalidation.seteticketdelivery": [
        null,
        "Par billets électroniques"
    ],
    "ordervalidation.setmaildelivery": [
        null,
        "Par la poste"
    ],
    "ordervalidation.shippingaddress": [
        null,
        "Adresse de livraison"
    ],
    "ordervalidation.title": [
        null,
        "Validez et complétez votre commande"
    ],
    "ordervalidation.yourinfo": [
        null,
        "Vos coordonnées"
    ],
    "payment.cardholdername": [
        null,
        "Titulaire de la carte"
    ],
    "payment.cardnumber": [
        null,
        "Numéro de la carte"
    ],
    "payment.cardnumberhelp": [
        null,
        "(sans les espaces)"
    ],
    "payment.cardvalidationnumber": [
        null,
        "Code à 3 ou 4 chiffres"
    ],
    "payment.carthasexpired": [
        null,
        "Le temps de transaction est écoulé. Votre panier d'achats est maintenant vide"
    ],
    "payment.completedelivery": [
        null,
        "La méthode de livraison de un ou plusieurs items de votre panier n'a pas été saisie"
    ],
    "payment.completetransaction": [
        null,
        "Compléter votre transaction"
    ],
    "payment.creditcardconditionnotmet": [
        null,
        "Type de carte de crédit invalide : Vous avez choisi un tarif demandant une carte de crédit {creditcard}"
    ],
    "payment.cvnhelp": [
        null,
        "(à l'endos de votre carte)"
    ],
    "payment.expirationdate": [
        null,
        "Date d'expiration"
    ],
    "payment.failedprocess": [
        null,
        "Une erreur est survenue lors de la transaction"
    ],
    "payment.finalizetransaction": [
        null,
        "Finalisation de votre transaction"
    ],
    "payment.itemsnotinsale": [
        null,
        "Les items suivants ne sont plus en vente sur le réseau : "
    ],
    "payment.numberofitemshaschange": [
        null,
        "Le nombre d'items dans votre panier d'achats a changé. Veuillez valider son contenu avant de compléter votre transaction"
    ],
    "payment.pay": [
        null,
        "Payer"
    ],
    "payment.paymentinfo": [
        null,
        "Informations de votre paiement"
    ],
    "politiques d'achats": [
        null,
        "politiques d'achats"
    ],
    "profileedition.accountalreadyexists": [
        null,
        "Un compte existe déjà avec cette adresse courriel"
    ],
    "profileedition.cancel": [
        null,
        "Annuler"
    ],
    "profileedition.confirm": [
        null,
        "Confirmer"
    ],
    "profileedition.contact": [
        null,
        "Contact"
    ],
    "profileedition.emailformat": [
        null,
        "Courriel invalide (ex: jonathan@gmail.com)"
    ],
    "profileedition.emailvalidationerror": [
        null,
        "La confirmation du courriel est invalide"
    ],
    "profileedition.errorhasoccured": [
        null,
        "Une erreur s'est produit lors de la sauvegarde, veuillez réessayer"
    ],
    "profileedition.fieldformatinvalid": [
        null,
        "Certains champs n'ont pas été saisie correctement"
    ],
    "profileedition.optional": [
        null,
        "(Optionnel)"
    ],
    "profileedition.passwordformat": [
        null,
        "Le mot de passe doit contenir plus de 6 caractères"
    ],
    "profileedition.passwordvalidation": [
        null,
        "Mot de passe (Confirmation): "
    ],
    "profileedition.passwordvalidationerror": [
        null,
        "La confirmation du mot de passe est invalide"
    ],
    "profileedition.personal": [
        null,
        "Personnel"
    ],
    "profileedition.phoneformat": [
        null,
        "Format de téléphone invalide (format valide : 4185453330)"
    ],
    "profileedition.postalcodeformat": [
        null,
        "Le format du code postal est invalide (ex: X0X 0X0 ou 12345)"
    ],
    "profileedition.requiredfieldmissing": [
        null,
        "Veuillez remplir tous les champs obligatoires"
    ],
    "profileedition.title.create": [
        null,
        "Création de votre profil"
    ],
    "profileedition.title.edition": [
        null,
        "Édition de votre profil"
    ],
    "profileinfo.address": [
        null,
        "Adresse"
    ],
    "profileinfo.address2": [
        null,
        "Adresse (suite)"
    ],
    "profileinfo.city": [
        null,
        "Ville"
    ],
    "profileinfo.country": [
        null,
        "Pays"
    ],
    "profileinfo.description": [
        null,
        "Description"
    ],
    "profileinfo.email": [
        null,
        "Courriel"
    ],
    "profileinfo.emailvalidation": [
        null,
        "Confirmation courriel"
    ],
    "profileinfo.female": [
        null,
        "Féminin"
    ],
    "profileinfo.firstname": [
        null,
        "Prénom"
    ],
    "profileinfo.lastname": [
        null,
        "Nom"
    ],
    "profileinfo.male": [
        null,
        "Masculin"
    ],
    "profileinfo.name": [
        null,
        "Nom complet"
    ],
    "profileinfo.password": [
        null,
        "Mot de passe"
    ],
    "profileinfo.phone1": [
        null,
        "Téléphone travail"
    ],
    "profileinfo.phone2": [
        null,
        "Téléphone domicile"
    ],
    "profileinfo.postalcode": [
        null,
        "Code postal"
    ],
    "profileinfo.province": [
        null,
        "Province"
    ],
    "profileinfo.sex": [
        null,
        "Sexe"
    ],
    "program.contactus.attheboxoffice": [
        null,
        "À la billetterie"
    ],
    "program.contactus.purschasebyphone": [
        null,
        "Acheter par téléphone"
    ],
    "program.eventdateinfo.buy": [
        null,
        "Acheter en ligne"
    ],
    "program.eventdateinfo.fewseats": [
        null,
        "Faites vite!"
    ],
    "program.eventdateinfo.newdate": [
        null,
        "Supplémentaire"
    ],
    "program.eventdateinfo.nodateavailable": [
        null,
        "Aucune date disponible"
    ],
    "program.eventdateinfo.selectadate": [
        null,
        "Sélectionnez une date"
    ],
    "program.eventdateinfo.soldout": [
        null,
        "Complet"
    ],
    "program.eventdateinfo.yourdate": [
        null,
        "Votre date"
    ],
    "program.format.moment.datetime": [
        null,
        "D MMMM YYYY - H[h]mm"
    ],
    "program.pricelist.startingfrom": [
        null,
        "À partir de *"
    ],
    "program.salesinfo.buyinpresale": [
        null,
        "Acheter en prévente"
    ],
    "program.salesinfo.notinsale": [
        null,
        "L'événement n'est plus en vente présentement"
    ],
    "program.salesinfo.pastevent": [
        null,
        "L'événement est passé"
    ],
    "program.salesinfo.public": [
        null,
        "Public"
    ],
    "program.salesinfo.soldoutevent": [
        null,
        "L'événement est complet"
    ],
    "program.ticketselection.nbrticketlabel": [
        null,
        "Nombre de billets désirés"
    ],
    "program.ticketselection.nbrtickettitle": [
        null,
        "Combien de billets désirez-vous?"
    ],
    "program.ticketselection.sectionlabel": [
        null,
        "Votre section"
    ],
    "program.ticketselection.sectiontitle": [
        null,
        "Désirez-vous une section en particulier?"
    ],
    "recherche": [
        null,
        "recherche"
    ],
    "retirer": [
        null,
        "retirer"
    ],
    "salequestionnaire.challenge": [
        null,
        "Épreuve"
    ],
    "salequestionnaire.firstname": [
        null,
        "Prénom"
    ],
    "salequestionnaire.lastname": [
        null,
        "Nom de famille"
    ],
    "shippingaddresspanel.addnew": [
        null,
        "Ajouter"
    ],
    "shippingaddresspanel.allshippingaddresses": [
        null,
        "Adresses de livraisons"
    ],
    "shippingaddresspanel.cancel": [
        null,
        "Annuler"
    ],
    "shippingaddresspanel.close": [
        null,
        "Fermer"
    ],
    "shippingaddresspanel.confirm": [
        null,
        "Confirmer"
    ],
    "shippingaddresspanel.edit": [
        null,
        "Modifier"
    ],
    "shippingaddresspanel.editShippingAddress": [
        null,
        "Modifier l'adresse de livraison"
    ],
    "shippingaddresspanel.errorhasoccured": [
        null,
        "Une erreur est survenue"
    ],
    "shippingaddresspanel.failedremove": [
        null,
        "Attention"
    ],
    "shippingaddresspanel.invalidpostalcodeformat": [
        null,
        "Veuillez-vous assurez que le code postal est valide"
    ],
    "shippingaddresspanel.loading": [
        null,
        "Veuillez patienter pendant que nous chargeons vos informations"
    ],
    "shippingaddresspanel.remove": [
        null,
        "Supprimer"
    ],
    "shippingaddresspanel.removeerror": [
        null,
        "Une erreur est survenue lors de la suppression. Veuillez réessayer"
    ],
    "shippingaddresspanel.requiredfieldmissing": [
        null,
        "Veuillez remplir tous les champs qui ne sont pas optionnels"
    ],
    "ticketpriceselection.addtocartandcontinueshopping": [
        null,
        "Ajouter et continuer mes achats"
    ],
    "ticketpriceselection.checkout": [
        null,
        "Passer à la caisse"
    ],
    "ticketpriceselection.hereareyourprices": [
        null,
        "Voici vos prix"
    ],
    "ticketpriceselection.membershipcardaddingsuccessfully": [
        null,
        "La carte de membre a été ajoutée au panier avec succès"
    ],
    "ticketpriceselection.membershipcardhasbeenfoundsuccessfully": [
        null,
        "Votre carte de membre a été trouvée avec succès"
    ],
    "ticketpriceselection.membersonly": [
        null,
        "Réservé aux membres"
    ],
    "ticketpriceselection.nopricesavailable": [
        null,
        "Aucun prix disponible"
    ],
    "ticketpriceselection.prices": [
        null,
        "Prix"
    ],
    "ticketpriceselection.qtytotalhigherthannumberofticketsreserved": [
        null,
        "Le total de vos quantités sélectionnées **({qtyrequest})** est plus grand que le nombre de billets **({nbrtickets})** réservés"
    ],
    "ticketpriceselection.qtytotallowerthannumberofticketsreserved": [
        null,
        "Le total de vos quantités sélectionnées **({qtyrequest})** est plus petit que le nombre de billets **({nbrtickets})** réservés"
    ],
    "ticketpriceselection.quantities": [
        null,
        "Quantités"
    ],
    "ticketpriceselection.rates": [
        null,
        "Tarifs"
    ],
    "ticketpriceselection.total": [
        null,
        "Total"
    ],
    "ticketpriceselection.totals": [
        null,
        "Totaux"
    ],
    "ticketpriceselection.yoursaving": [
        null,
        "Économisez **{amount}** avec la carte "
    ],
    "venueplan.contextmenu.cancel": [
        null,
        "Annuler"
    ],
    "venueplan.contextmenu.lookfortickethere": [
        null,
        "Chercher ici"
    ],
    "veuillez envoyer un courriel à ": [
        null,
        "veuillez envoyer un courriel à "
    ],
    "vider": [
        null,
        "vider"
    ],
    "year": [
        null,
        "année"
    ],
    "{ticketsNumber} billets": [
        null,
        "{ticketsNumber} billets"
    ],
    "{ticketsNumber} billets {sectionName}": [
        null,
        "{ticketsNumber} billets {sectionName}"
    ],
    "Éditer vos informations": [
        null,
        "Éditer vos informations"
    ],
    "Êtes-vous membre ?": [
        null,
        "Êtes-vous membre ?"
    ],
    "à intéragir avec ce site Web.": [
        null,
        "à intéragir avec ce site Web."
    ],
    "à intéragir sur le site de": [
        null,
        "à intéragir sur le site de"
    ],
    "Une erreur est survenue. Veuillez réessayer.": [
        null,
        "Une erreur est survenue. Veuillez réessayer."
    ],
    "(Québec)": [
        null,
        "(Québec)"
    ],
    "10h à 17h {timezone}": [
        null,
        "10h à 17h {timezone}"
    ],
    "8h à 16h {timezone}": [
        null,
        "8h à 16h {timezone}"
    ],
    "930 boul. Jacques-Cartier Est": [
        null,
        "930 boul. Jacques-Cartier Est"
    ],
    "9h à 20h {timezone}": [
        null,
        "9h à 20h {timezone}"
    ],
    "Accéder à la liste des spectacles": [
        null,
        "Accéder à la liste des spectacles"
    ],
    "Acheter": [
        null,
        "Acheter"
    ],
    "Acheté le : {purchaseDate}": [
        null,
        "Acheté le {purchaseDate}"
    ],
    "Administration": [
        null,
        "Administration"
    ],
    "Admission générale": [
        null,
        "Admission générale"
    ],
    "Adresse": [
        null,
        "Adresse"
    ],
    "Adresse (suite)": [
        null,
        "Adresse (suite)"
    ],
    "Adresse courriel": [
        null,
        "Adresse courriel"
    ],
    "Adresse de facturation": [
        null,
        "Adresse de facturation"
    ],
    "Adresses de livraison": [
        null,
        "Adresses de livraison"
    ],
    "Adulte": [
        null,
        "Adulte"
    ],
    "Afficher plus": [
        null,
        "Afficher plus"
    ],
    "Ancien mot de passe": [
        null,
        "Ancien mot de passe"
    ],
    "Annulé": [
        null,
        "Annulé"
    ],
    "Bonjour": [
        null,
        "Bonjour"
    ],
    "Bureau B-101": [
        null,
        "Bureau B-101"
    ],
    "Bureau administratif": [
        null,
        "Bureau administratif"
    ],
    "Cacher": [
        null,
        "Cacher"
    ],
    "Capacité de la salle": [
        null,
        "Capacité de la salle"
    ],
    "Ce champ est requis.": [
        null,
        "Ce champ est requis."
    ],
    "Centrale téléphonique": [
        null,
        "Centrale téléphonique"
    ],
    "Chicoutimi": [
        null,
        "Chicoutimi"
    ],
    "Combien de représentations avez-vous planifiées ?": [
        null,
        "Combien de représentations avez-vous planifiées?"
    ],
    "Commande annulée": [
        null,
        "Commande annulée"
    ],
    "Commentaires": [
        null,
        "Commentaires"
    ],
    "Complet": [
        null,
        "Complet"
    ],
    "Confirmation du nouveau mot de passe": [
        null,
        "Confirmation du nouveau mot de passe"
    ],
    "Confirmez votre nouveau mot de passe": [
        null,
        "Confirmez votre nouveau mot de passe"
    ],
    "Confirmez votre nouvelle adresse courriel": [
        null,
        "Confirmez votre nouvelle adresse courriel"
    ],
    "Connectez-vous": [
        null,
        "Connectez-vous"
    ],
    "Contact": [
        null,
        "Contact"
    ],
    "Courriel": [
        null,
        "Courriel"
    ],
    "Courriel :": [
        null,
        "Courriel :"
    ],
    "Courriel existant.": [
        null,
        "Courriel existant."
    ],
    "Date de la première représentation": [
        null,
        "Date de la première représentation"
    ],
    "Description": [
        null,
        "Description"
    ],
    "Du {fromDate}": [
        null,
        "Du {fromDate}"
    ],
    "Désirez-vous vraiment supprimer cette adresse?": [
        null,
        "Désirez-vous vraiment supprimer cette adresse?"
    ],
    "Email": [
        null,
        "Courriel"
    ],
    "En panne d'idée cadeau?": [
        null,
        "En panne d'idée cadeau?"
    ],
    "En savoir plus": [
        null,
        "En savoir plus"
    ],
    "Enfant": [
        null,
        "Enfant"
    ],
    "English": [
        null,
        "English"
    ],
    "Femme": [
        null,
        "Femme"
    ],
    "Fermé": [
        null,
        "Fermé"
    ],
    "Français": [
        null,
        "Français"
    ],
    "G7H 7K9": [
        null,
        "G7H 7K9"
    ],
    "HAE": [
        null,
        "HAE"
    ],
    "HNE": [
        null,
        "HNE"
    ],
    "Heures d'affaires": [
        null,
        "Heures d'affaires"
    ],
    "Homme": [
        null,
        "Homme"
    ],
    "Informations à propos de votre événement": [
        null,
        "Informations à propos de votre événement"
    ],
    "J'ai les informations de l'événement": [
        null,
        "J’ai les informations de l’événement"
    ],
    "Je m'abonne": [
        null,
        "Je m'abonne"
    ],
    "Jusqu'au {toDate}": [
        null,
        "Jusqu’au {toDate}"
    ],
    "La confirmation du mot de passe doit être identique au nouveau": [
        null,
        "La confirmation du mot de passe doit être identique au nouveau"
    ],
    "Le cas échéant, qui vous a référé ?": [
        null,
        "Le cas échéant, qui vous a référé?"
    ],
    "Le mot de passe doit comprendre entre 5 et 25 caractères": [
        null,
        "Le mot de passe doit comprendre entre 5 et 25 caractères"
    ],
    "Les champs en rouge sont obligatoires": [
        null,
        "Les champs en rouge sont obligatoires"
    ],
    "Les deux": [
        null,
        "Les deux"
    ],
    "Lundi au vendredi": [
        null,
        "Lundi au vendredi"
    ],
    "M'enregistrer": [
        null,
        "M'enregistrer"
    ],
    "Mauvais mot de passe.": [
        null,
        "Mauvais mot de passe."
    ],
    "Me connecter": [
        null,
        "Me connecter"
    ],
    "Me déconnecter": [
        null,
        "Me déconnecter"
    ],
    "Mes commandes": [
        null,
        "Mes commandes"
    ],
    "Modification de l'adresse courriel": [
        null,
        "Modification de l'adresse courriel"
    ],
    "Modifier le profil": [
        null,
        "Modifier le profil"
    ],
    "Modifier votre mot de passe": [
        null,
        "Modifier votre mot de passe"
    ],
    "Mon profil": [
        null,
        "Mon profil"
    ],
    "Mot de passe": [
        null,
        "Mot de passe"
    ],
    "Mots de passes différents": [
        null,
        "Mots de passes différents"
    ],
    "Nom": [
        null,
        "Nom"
    ],
    "Nom complet": [
        null,
        "Nom complet"
    ],
    "Nom de famille": [
        null,
        "Nom de famille"
    ],
    "Nom de la compagnie": [
        null,
        "Nom de la compagnie"
    ],
    "Nom de la salle": [
        null,
        "Nom de la salle"
    ],
    "Nom de votre ou de vos événement(s) ?": [
        null,
        "Nom de votre ou de vos événement(s)?"
    ],
    "Non": [
        null,
        "Non"
    ],
    "Nous joindre": [
        null,
        "Nous joindre"
    ],
    "Nous n'avons trouvé aucun résultat pour votre recherche.": [
        null,
        "Nous n'avons trouvé aucun résultat pour votre recherche."
    ],
    "Nouveau mot de passe": [
        null,
        "Nouveau mot de passe"
    ],
    "Nouvelle adresse courriel": [
        null,
        "Nouvelle adresse courriel"
    ],
    "Ok": [
        null,
        "Ok"
    ],
    "Optez pour un certificat-cadeau Reservatech.net. Choisissez le montant que vous désirez!": [
        null,
        "Optez pour une carte cadeau Reservatech.net. Choisissez le montant que vous désirez!"
    ],
    "Optionnel": [
        null,
        "Optionnel"
    ],
    "Oui": [
        null,
        "Oui"
    ],
    "Par catégorie": [
        null,
        "Par catégorie"
    ],
    "Par date": [
        null,
        "Par date"
    ],
    "Par région": [
        null,
        "Par région"
    ],
    "Par salle": [
        null,
        "Par salle"
    ],
    "Par événement ou artiste": [
        null,
        "Par événement ou artiste"
    ],
    "Pays": [
        null,
        "Pays"
    ],
    "Points de vente": [
        null,
        "Points de vente"
    ],
    "Profil": [
        null,
        "Profil"
    ],
    "Programmation complète": [
        null,
        "Programmation complète"
    ],
    "Province": [
        null,
        "Province"
    ],
    "Prénom": [
        null,
        "Prénom"
    ],
    "Quand prévoyez-vous la mise en vente publique ?": [
        null,
        "Quand prévoyez-vous la mise en vente publique ?"
    ],
    "Quel est le prix des billets ?": [
        null,
        "Quel est le prix des billets?"
    ],
    "Quel est le type de billet ?": [
        null,
        "Quel est le type de billet?"
    ],
    "Recevez toutes les nouvelles sur les spectacles à venir, les dates de mise en vente de billets, nos concours et plus encore...": [
        null,
        "Recevez toutes les nouvelles sur les spectacles à venir, les dates de mise en vente de billets, nos concours et plus encore..."
    ],
    "Restez informés": [
        null,
        "Restez informés"
    ],
    "Retourner à l'accueil": [
        null,
        "Retourner à l'accueil"
    ],
    "Retourner à la vente standard": [
        null,
        "Retourner à la vente standard"
    ],
    "Réinitialisation de votre mot de passe": [
        null,
        "Réinitialisation de votre mot de passe"
    ],
    "Résultats": [
        null,
        "Résultats"
    ],
    "Samedi et dimanche": [
        null,
        "Samedi et dimanche"
    ],
    "Sièges réservés": [
        null,
        "Sièges réservés"
    ],
    "Suivez-nous": [
        null,
        "Suivez-nous"
    ],
    "Titre": [
        null,
        "Titre"
    ],
    "Tél. :": [
        null,
        "Tél. :"
    ],
    "Télécopieur :": [
        null,
        "Télécopieur :"
    ],
    "Téléphone :": [
        null,
        "Téléphone :"
    ],
    "Téléphone sans frais :": [
        null,
        "Téléphone sans frais :"
    ],
    "Une erreur est apparue. Veuillez réessayer plus tard.": [
        null,
        "Une erreur est apparue. Veuillez réessayer plus tard."
    ],
    "Une fois votre demande de modification de votre courriel effectuée, un courriel sera envoyé à votre nouvelle adresse pour que vous puissiez confirmer la modification.": [
        null,
        "Une fois votre demande de modification de votre courriel effectuée, un courriel sera envoyé à votre nouvelle adresse pour que vous puissiez confirmer la modification."
    ],
    "Vendre un événement sur notre réseau": [
        null,
        "Vendre un événement sur notre réseau"
    ],
    "Veuillez prendre note qu’un courriel sera également envoyé à votre ancienne adresse pour mentionner la demande de changement.": [
        null,
        "Veuillez prendre note qu’un courriel sera également envoyé à votre ancienne adresse pour mentionner la demande de changement."
    ],
    "Veuillez remplir tous les champs qui ne sont pas optionnels": [
        null,
        "Veuillez remplir tous les champs qui ne sont pas optionnels"
    ],
    "Veuillez remplir tous les champs qui ne sont pas optionnels et vous assurer que le code postal est valide": [
        null,
        "Veuillez remplir tous les champs qui ne sont pas optionnels et vous assurer que le code postal est valide"
    ],
    "Veuillez saisir un mot de passe de 5 à 11 lettres et/ou chiffres": [
        null,
        "Veuillez saisir un mot de passe de 5 à 11 lettres et/ou chiffres"
    ],
    "Veuillez vous assurer que le code postal est valide": [
        null,
        "Veuillez vous assurer que le code postal est valide"
    ],
    "Vider": [
        null,
        "Vider"
    ],
    "Vidéo promotionnelle": [
        null,
        "Vidéo promotionnelle"
    ],
    "Ville": [
        null,
        "Ville"
    ],
    "Ville de la salle": [
        null,
        "Ville de la salle"
    ],
    "Voir la commande": [
        null,
        "Voir la commande"
    ],
    "Vos Informations": [
        null,
        "Vos Informations"
    ],
    "Vos commandes": [
        null,
        "Vos commandes"
    ],
    "Votre compte": [
        null,
        "Votre compte"
    ],
    "Votre mot de passe a bien été changé.": [
        null,
        "Votre mot de passe a bien été changé."
    ],
    "Vous avez déjà modifié votre mot de passe.": [
        null,
        "Vous avez déjà modifié votre mot de passe."
    ],
    "Vous n'avez encore fait aucun achat.": [
        null,
        "Vous n'avez encore fait aucun achat."
    ],
    "© {currentYear} Reservatech | Tous droits réservés": [
        null,
        "© {currentYear} Reservatech | Tous droits réservés"
    ],
    "Événements les plus populaires": [
        null,
        "Événements les plus populaires"
    ],
    "Événements nouvellement mis en vente": [
        null,
        "Événements nouvellement mis en vente"
    ],
    "Événements à venir": [
        null,
        "Événements à venir"
    ],
    "Code postal invalide": [
        null,
        "Code postal invalide"
    ],
    "Le nombre doit être un entier": [
        null,
        "Le nombre doit être un entier"
    ],
    "Nombre invalide": [
        null,
        "Nombre invalide"
    ],
    "Vous devez cocher la case pour continuer": [
        null,
        "Vous devez cocher la case pour continuer"
    ],
    "general.pleasewait": [
        null,
        "Veuillez patienter…"
    ],
    "tsadminreactcontrols.noitem": [
        null,
        "Aucun item"
    ],
    "tsadminreactcontrols.processing": [
        null,
        "Processus en cours..."
    ],
    "paging.first": [
        null,
        "Première"
    ],
    "paging.last": [
        null,
        "Dernière"
    ],
    "paging.next": [
        null,
        "Suivant"
    ],
    "paging.previous": [
        null,
        "Précédent"
    ]
};